/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PatchEquipementQrCodeDto } from '../../models/patch-equipement-qr-code-dto';

export interface UpsertEquipementQrCode$Params {
  body: PatchEquipementQrCodeDto;
}

export function upsertEquipementQrCode(
  http: HttpClient,
  rootUrl: string,
  params: UpsertEquipementQrCode$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<{}>> {
  const rb = new RequestBuilder(rootUrl, upsertEquipementQrCode.PATH, 'patch');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'blob', accept: '*/*', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{}>;
    })
  );
}

upsertEquipementQrCode.PATH = '/v1/equipements/qrCode';
